import React from "react";
import styled from "@emotion/styled";

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr 1px 1fr 1px 1fr;
  grid-gap: 20px;
  margin-top: 71px;
  margin-bottom: 100px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr 1px 1fr;
    grid-row-gap: 25px;
  }
`;

const InfoItem = styled.div`
  text-align: center;
`;

const InfoText = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.63;
  text-align: center;
  color: #1f2021;
  margin-top: 25px;
`;

const BorderLine = styled.div`
  width: 1px;
  height: 100%;
  opacity: 0.15;
  background-image: linear-gradient(
    to bottom,
    rgba(66, 67, 69, 0.2),
    #1f2021 52%,
    rgba(31, 32, 33, 0.2)
  );
`;

const LargeScreenBorderLine = styled(BorderLine)`
  display: ${props => props.setDisplay};

  @media (max-width: 500px) {
    display: none;
  }
`;

const MobileBorderLine = styled(BorderLine)`
  @media (min-width: 501px) {
    display: none;
  }

  display: ${props => props.setDisplay};
`;

const infoArray = [
  {
    img: "https://cdn.cardcash.com/website/ui/elements/rating-five-star.svg",
    text: "Ranked Best Gift Card Exchange Site"
  },
  {
    img: "https://cdn.cardcash.com/website/ui/elements/safe.svg",
    text: "45-day Guarantee"
  },
  {
    img: "https://cdn.cardcash.com/website/ui/elements/shield2.svg",
    text: "Safe and Secure"
  },
  {
    img: "https://cdn.cardcash.com/website/ui/elements/thumbs-up.svg",
    text: "Trusted"
  }
];

const CartInfoGrid = () => {
  const isOdd = num => num % 2;

  return (
    <InfoGrid>
      {infoArray.map((item, index) => (
        <React.Fragment key={index}>
          <InfoItem>
            <img src={item.img} alt="info" />
            <InfoText>{item.text}</InfoText>
          </InfoItem>
          <LargeScreenBorderLine setDisplay={index < 3 ? "initial" : "none"} />
          <MobileBorderLine setDisplay={!isOdd(index) ? "initial" : "none"} />
        </React.Fragment>
      ))}
    </InfoGrid>
  );
};

export default CartInfoGrid;
